import { lazy, Suspense } from "react";

// Lazy load toaster components - they're not needed until a toast is shown
const Toaster = lazy(() => 
  import("@/components/ui/toaster").then(mod => ({ default: mod.Toaster }))
);
const Sonner = lazy(() => 
  import("@/components/ui/sonner").then(mod => ({ default: mod.Toaster }))
);

export const LazyToasters = () => (
  <Suspense fallback={null}>
    <Toaster />
    <Sonner />
  </Suspense>
);
